export const page = { minHeight: '100vh', background: '#faf8f3', padding: '2rem 16px', color: '#1a1a1a' };
export const wrap = { maxWidth: 960, margin: '0 auto' };
export const card = { background: '#ffffff', border: '1px solid #d8c9a8', borderRadius: 8, padding: '1.25rem 1.5rem', marginBottom: '1.25rem' };
export const h1 = { margin: '0 0 0.25rem', color: '#1a1a1a' };
export const h2 = { margin: '0 0 0.75rem', fontSize: '1.05rem', color: '#1a1a1a' };
export const muted = { margin: '0 0 1rem', color: '#7f7f7f', fontSize: '0.9rem', lineHeight: 1.5 };
export const grid = { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(190px, 1fr))', gap: '0.9rem' };
export const label = { display: 'block', fontSize: '0.8rem', color: '#7f7f7f', marginBottom: 4 };
export const input = { width: '100%', boxSizing: 'border-box', padding: '8px 10px', border: '1px solid #d8c9a8', borderRadius: 6, fontSize: '0.95rem' };
export const btn = { backgroundColor: '#1a1a1a', color: '#D4AF37', border: 'none', padding: '8px 14px', borderRadius: 6, fontWeight: 600, cursor: 'pointer', fontSize: '0.9rem' };
export const backBtn = { background: 'none', border: 'none', color: '#8C6D1F', cursor: 'pointer', padding: 0, marginBottom: '1rem', fontSize: '0.95rem' };
export const row = { display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderBottom: '1px solid #f0ebe0', fontSize: '0.95rem' };
export const bigRow = { ...row, fontWeight: 700, fontSize: '1.1rem', borderBottom: 'none', paddingTop: 10 };
export const table = { width: '100%', borderCollapse: 'collapse', fontSize: '0.9rem' };
export const th = { textAlign: 'left', fontSize: '0.75rem', color: '#7f7f7f', padding: '6px 4px', borderBottom: '1px solid #d8c9a8' };
export const td = { padding: '6px 4px', borderBottom: '1px solid #f0ebe0', verticalAlign: 'middle' };

export const money = (n) => {
  const v = Number.isFinite(n) ? n : 0;
  return v.toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
};
export const num = (v) => {
  const n = parseFloat(v);
  return Number.isFinite(n) ? n : 0;
};
